<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >
    <!-- Content Left -->
    <b-col class="content-header-left mb-2" cols="12" md="9">
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2
            id="breadcrumbsPageTitle"
            class="content-header-title float-left pr-1 mb-0"
          >
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item to="/dashboard">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="3"
      cols="12"
      v-if="$route.path.includes('/statistics')"
      style="display: flex !important;"
    >
      <b-col class="col-8">
        <b-form-group>
          <flat-pickr
            v-model="rangeDate"
            class="form-control"
            :config="{ mode: 'range', dateFormat: 'Y-m-d' }"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-4">
        <b-button @click="setDate()" variant="primary">{{
          $t("stats.select")
        }}</b-button>
      </b-col>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormGroup,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    flatPickr,
    BFormGroup,
  },
  data() {
    return {
      rangeDate: null,
    };
  },
  methods: {
    setDate() {
      if (this.rangeDate) {
        this.$store.commit("set_date", this.rangeDate);
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
